// Define global variables to store current slider values
window.currentSliderValues = {
    desktop: { min: 0, max: 0 },
    mobile: { min: 0, max: 0 }
};

document.addEventListener("DOMContentLoaded", function () {
    var rangeSlider = document.querySelector('.range-slider');
    var maxPrice = parseFloat(rangeSlider.dataset.maxPrice); 
    var minPrice = 0; // Fixed min value

    // Initialize current slider values
    window.currentSliderValues.desktop = { min: minPrice, max: maxPrice };
    window.currentSliderValues.mobile = { min: minPrice, max: maxPrice };

    // Utility function to trigger events
    function triggerEvent(element, eventType) {
        var event;
        if (typeof(Event) === 'function') {
            event = new Event(eventType, { bubbles: true });
        } else {
            event = document.createEvent('Event');
            event.initEvent(eventType, true, true);
        }
        element.dispatchEvent(event); 
    }

    // Function to initialize the desktop slider
    window.initDesktopSlider = function() {
        var slider = document.getElementById("slider-range");
        var inputMin = document.querySelector(".input-min");
        var inputMax = document.querySelector(".input-max");

        // Use stored slider values
        var currentMin = window.currentSliderValues.desktop.min;
        var currentMax = window.currentSliderValues.desktop.max;

        // Update the global currentSliderValues based on input fields
        if (inputMin.value) {
            currentMin = parseFloat(inputMin.value);
            window.currentSliderValues.desktop.min = currentMin;
        }
        if (inputMax.value) {
            currentMax = parseFloat(inputMax.value);
            window.currentSliderValues.desktop.max = currentMax;
        }

        // console.log('Initializing Desktop Slider with:', currentMin, currentMax);

        // Destroy existing slider if necessary
        if ($(slider).data('ui-slider')) {
            $(slider).slider('destroy');
        }

        // Initialize the slider with current values
        $(slider).slider({
            range: true,
            min: minPrice,
            max: maxPrice,
            values: [currentMin, currentMax],
            slide: function (event, ui) {
                inputMin.value = ui.values[0];
                inputMax.value = ui.values[1];

                // Update stored values
                window.currentSliderValues.desktop.min = ui.values[0];
                window.currentSliderValues.desktop.max = ui.values[1];

                // console.log('Desktop Slider Updated:', window.currentSliderValues.desktop);

                triggerEvent(inputMin, 'input');
                triggerEvent(inputMax, 'input');

                triggerEvent(inputMin, 'change');
                triggerEvent(inputMax, 'change');
            }
        });

        // Update slider values when inputs change
        inputMin.removeEventListener('change', updateSliderFromInputs);
        inputMax.removeEventListener('change', updateSliderFromInputs);

        inputMin.addEventListener('change', updateSliderFromInputs);
        inputMax.addEventListener('change', updateSliderFromInputs);

        function updateSliderFromInputs() {
            var minValue = parseFloat(inputMin.value) || minPrice;
            var maxValue = parseFloat(inputMax.value) || maxPrice;
            if (minValue < minPrice) minValue = minPrice;
            if (maxValue > maxPrice) maxValue = maxPrice;
            if (minValue > maxValue) minValue = maxValue;
            window.currentSliderValues.desktop.min = minValue;
            window.currentSliderValues.desktop.max = maxValue;
            $(slider).slider('values', [minValue, maxValue]);

            // console.log('Desktop Slider Input Changed:', window.currentSliderValues.desktop);
        }
    };

    // Function to initialize the mobile slider
    window.initMobileSlider = function() {
        var slider = document.getElementById("mb-slider-range");
        var inputMin = document.querySelector(".mb-input-min");
        var inputMax = document.querySelector(".mb-input-max");

        // Use stored slider values
        var currentMin = window.currentSliderValues.mobile.min;
        var currentMax = window.currentSliderValues.mobile.max;

        // Update the global currentSliderValues based on input fields
        if (inputMin.value) {
            currentMin = parseFloat(inputMin.value);
            window.currentSliderValues.mobile.min = currentMin;
        }
        if (inputMax.value) {
            currentMax = parseFloat(inputMax.value);
            window.currentSliderValues.mobile.max = currentMax;
        }

        // console.log('Initializing Mobile Slider with:', currentMin, currentMax);

        // Destroy existing slider if necessary
        if ($(slider).data('ui-slider')) {
            $(slider).slider('destroy');
        }

        // Initialize the slider with current values
        $(slider).slider({
            range: true,
            min: minPrice,
            max: maxPrice,
            values: [currentMin, currentMax],
            slide: function (event, ui) {
                inputMin.value = ui.values[0];
                inputMax.value = ui.values[1];

                // Update stored values
                window.currentSliderValues.mobile.min = ui.values[0];
                window.currentSliderValues.mobile.max = ui.values[1];

                // console.log('Mobile Slider Updated:', window.currentSliderValues.mobile);

                triggerEvent(inputMin, 'input');
                triggerEvent(inputMax, 'input');

                triggerEvent(inputMin, 'change');
                triggerEvent(inputMax, 'change');
            }
        });

        // Update slider values when inputs change
        inputMin.removeEventListener('change', updateSliderFromInputs);
        inputMax.removeEventListener('change', updateSliderFromInputs);

        inputMin.addEventListener('change', updateSliderFromInputs);
        inputMax.addEventListener('change', updateSliderFromInputs);

        function updateSliderFromInputs() {
            var minValue = parseFloat(inputMin.value) || minPrice;
            var maxValue = parseFloat(inputMax.value) || maxPrice;
            if (minValue < minPrice) minValue = minPrice;
            if (maxValue > maxPrice) maxValue = maxPrice;
            if (minValue > maxValue) minValue = maxValue;
            window.currentSliderValues.mobile.min = minValue;
            window.currentSliderValues.mobile.max = maxValue;
            $(slider).slider('values', [minValue, maxValue]);

            // console.log('Mobile Slider Input Changed:', window.currentSliderValues.mobile);
        }
    };

    // Check for window size and initialize the correct slider
    if (window.innerWidth > 768) {
        window.initDesktopSlider();
    } else {
        window.initMobileSlider();
    }

    // Re-initialize sliders on window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768) {
            window.initDesktopSlider();
        } else {
            window.initMobileSlider();
        }
    });
});


